import { render } from "./ContactUs.vue?vue&type=template&id=33e2fa98&scoped=true"
const script = {}

import "./ContactUs.vue?vue&type=style&index=0&id=33e2fa98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e2fa98"]])

export default __exports__